var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadingMarkers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243.841,
    height: 232.875,
    viewBox: "0 0 243.841 232.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-960 -732.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4785",
    d: "M200.453,77.613V104",
    transform: "translate(881.564 655.234)",
    fill: "none",
    stroke: "#ff0606",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5663",
    d: "M92.225,187.814l-13.789,4.918V182.9Zm216.264,0,13.789,4.918V182.9ZM200.453,296.7l4.917,13.789h-9.835Zm-76.622-32.4-6.273,13.227-6.954-6.954ZM276.753,111.38l13.227-6.272-6.955-6.955ZM123.5,110.909l-13.227-6.273,6.954-6.954ZM277.353,264.766l13.227,6.273-6.954,6.954Z",
    transform: "translate(881.564 655.234)",
    fill: "#ff3506",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingMarkers);
export default __webpack_public_path__ + "static/media/heading-markers.9975c874c8ecfffe79a7d2a3c865420d.svg";
export { ForwardRef as ReactComponent };